<template>
  <div id="app">
    <router-view/>
    <div style="margin-top: 30px">
      <a target="_blank" style="color: #5c6b77" href="https://beian.miit.gov.cn/">蜀ICP备19002768号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue